import React, { useState, useEffect } from "react";
import { TextInput } from "../../Components/Inputs";
import init_customer from "../init_customer";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";

const AddCustomer = () => {
  const [input, setInput] = useState(init_customer);
  const navigate = useNavigate();
  const request = useAxios();

  // ✅ Reset form whenever AddCustomer mounts
  useEffect(() => {
    setInput(init_customer);
  }, []);

  const handleSubmit = async (data) => {
    let res = await request({
      method: "POST",
      url: "customers/add",
      body: data,
    });
    if (res === "error") return;
    navigate("/dashboard/customers");
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12 rounded-md">
      <h3 className="text-center text-xl font-semibold">Add Customer</h3>
      <div className="mt-4">
        <TextInput
          input={input}
          setInput={setInput}
          field="name"
          validate={validate}
        />

        <TextInput
          input={input}
          setInput={setInput}
          field="company_name"
          validate={validate}
        />

        <div className="flex gap-5 items-center max-md:flex-col">
          <TextInput
            input={input}
            setInput={setInput}
            field="email"
            validate={validate}
          />
          <TextInput
            input={input}
            setInput={setInput}
            field="phone_no"
            validate={validate}
          />
        </div>

        <TextInput
          input={input}
          setInput={setInput}
          field="address"
          validate={validate}
        />
      </div>
      <div className="mt-4 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/customers")}>Back</Btn>
        <Btn onClick={handleValidation}>Submit</Btn>
      </div>
    </div>
  );
};

export default AddCustomer;
